import Action from '../../Action'
import './styles/ModalDeleteUSer.css'
import { useState } from 'react';
import LoadSimple from '../../LoadSimple';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
import { logAuditAction } from '../../../utils/auditLogger';
const ModalDeleteBrand = ({ handleShowPopup, languaje, mode, buscar_cis, user, closDeleteUserModal, setData, setLoading, setError, server }) => {
  const [loadingM, setLoadingM] = useState(false);
  const getCurrentDateTime = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };
  const Eliminar = () => {
    setLoadingM(true)
    const fetchDataPost = async () => {

      try {
        const response = await fetch(server.url + '/api/v1/cassia/device_metrics/active/' + user.id, {
          // const response = await fetch(server.url+'/api/v1/cassia/device_metrics/'+user.id, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          },
          body: JSON.stringify({
            "closed_at": "" + getCurrentDateTime()
          })
        });
        if (response.ok) {

          const data1 = await response.json();
          setLoadingM(false)
          // Manejo de la respuesta
          setData(data1)
          buscar_cis()
          handleShowPopup(capitalizeFirstLetter(lang[languaje]['completado']), capitalizeFirstLetter((lang[languaje]['regDeleteCorr'])), '', true)
          logAuditAction(
            "Eliminar",
            `Medición ID: ${user.id}`,
            "Mediciones"
          );
          closDeleteUserModal()

          // console.log(data1);
        } else {
          const data1 = await response.json();
          setLoadingM(false)
          // closDeleteUserModal()
          handleShowPopup('Error!!!', capitalizeFirstLetter(lang[languaje]['regDeleteNoCorr']), data1.detail, false)

          throw new Error('Error en la solicitud');
        }
      } catch (error) {
        // Manejo de errores
        // handleShowPopup('Error!!!',capitalizeFirstLetter(lang[languaje]['regDeleteNoCorr']),capitalizeFirstLetter(lang[languaje]['reportError']), false)
        setError(error)
        console.error(error);
      }
    };

    fetchDataPost();
  }
  return (
    <div className="modal-GS-content">
      <div className='card-modal-gs delete-modal-gs'>
        {/* <div className='head-card-users delete-modal-gs'>
                                <div className='title-head-card-modal-gs'>
                                   CERRAR EXCEPCION
                                </div>
                            </div> */}
        <div className='content-card-modal-gs'>
          <div className='cont-info-modal-delete-gs'>
            <div className='cont-message-modal-delete-gs'>
              <div className='txt-message-modal-delete-gs'>
                {lang[languaje]['eliminar'].toUpperCase() + "  " + lang[languaje]['medicion'].toUpperCase()}:
              </div>
            </div>
            <div className='cont-user-modal-delete-gs'>
              <div className='txt-user-modal-delete-gs'>
                {user.visible_name + " - " + user.visible_name + " - " + user.model_name}
              </div>
            </div>
            <div className='cont-btn-modal-delete-gs'>
              {
                (loadingM) ? <LoadSimple></LoadSimple> :
                  <>
                    <Action disabled={false} origen='Red' titulo={capitalizeFirstLetter(lang[languaje]['eliminar'])} action={Eliminar}></Action>
                    <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])} action={closDeleteUserModal}></Action>
                  </>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalDeleteBrand